<div ngbAccordion #accordion="ngbAccordion" *ngIf="!loading">
  <div ngbAccordionItem="first" [collapsed]="!upcomingAssignment.length">
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="flex-row-reverse">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center gap-2">
              <div class="title">{{ 'PANEL.LMS.ASSIGNMENTS.UPCOMING' | translate }}</div>
              <div class="tag">{{upcomingAssignment.length}}</div>
            </div>
        </div>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="accordion-content">
            @if (upcomingAssignment.length) {
            <ul class="assignments-list m-0 p-0">
              <li class="assignment-item" *ngFor="let item of upcomingAssignment">
                <div class="assignment-header d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <div class="tag-lg d-flex align-items-center gap-1">
                      <svg-icon src="/assets/Icons/new/pencil paper.svg"></svg-icon>
                    </div>
                    <div class="assignment-info">
                                <div class="title">{{item.title}} <span class="description">({{item.lessonTitle}})</span>
                                  <span class="tag tag-light-primary me-2 ms-2" *ngIf="item.isSubmitted">
                                    <svg-icon src="/assets/Icons/new/check-circle.svg"></svg-icon>
                                    {{ 'PANEL.LMS.ASSIGNMENTS.SUBMITTED' | translate }}
                                  </span>
                                  <span class="tag tag-light-primary" *ngIf="item.status==20">
                                    <svg-icon src="/assets/Icons/new/check-circle.svg"></svg-icon>
                                    {{ 'PANEL.LMS.ASSIGNMENTS.DONE' | translate }}
                                  </span>
                                  <span class="tag tag-blue" *ngIf="item.status==10">
                                    {{ 'PANEL.LMS.ASSIGNMENTS.NEEDS_IMPROVEMENT' | translate }}
                                  </span>
                                </div>
                      <div class="sub" *ngIf="item.dueDate">
                        {{ 'PANEL.LMS.ASSIGNMENTS.DUE' | translate }} <span>{{item.dueDate | date:'MMM d h:mm a'}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="more d-flex">
                    <div class="tag tag-2 me-2" *ngIf="item.submitDate">{{item.submitDate | date:'MMMM d'}} -
                      <ng-container *ngIf="item.onTime">{{ 'PANEL.LMS.ASSIGNMENTS.ON_TIME' | translate }}</ng-container>
                      <ng-container *ngIf="!item.onTime">{{ 'PANEL.LMS.ASSIGNMENTS.LATE_SUBMISSION' | translate }}</ng-container>
                    </div>
                    <a [routerLink]="['./assignments',item.id]" routerLinkActive="router-link-active"
                      [queryParamsHandling]="'preserve'" class="btn btn-text d-flex align-items-center gap-2">
                      {{ 'PANEL.LMS.LESSONS.VIEW_DETAILS' | translate }}
                      <svg-icon src="/assets/Icons/new/angle-right-green.svg"></svg-icon>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            }
          </div>
        </ng-template>
      </div>
    </div>
  </div>


  <div ngbAccordionItem="second" [collapsed]="!pastAssignment.length">
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="flex-row-reverse">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center gap-2">
            <div class="title">{{ 'PANEL.LMS.ASSIGNMENTS.PAST' | translate }}</div>
            <div class="tag">{{pastAssignment.length}}</div>
          </div>
        </div>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>

          <div class="accordion-content">
            @if (pastAssignment.length) {
            <ul class="assignments-list m-0 p-0">
              <li class="assignment-item" *ngFor="let item of pastAssignment">
                <div class="assignment-header d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <div class="tag-lg d-flex align-items-center gap-1">
                      <svg-icon src="/assets/Icons/new/pencil paper.svg"></svg-icon>
                    </div>
                    <div class="assignment-info">
                      <div class="title">{{item.title}} <span class="description">({{item.lessonTitle}})</span>
                        <span class="tag tag-light-primary ms-2 me-2" *ngIf="item.isSubmitted">
                          <svg-icon src="/assets/Icons/new/check-circle.svg"></svg-icon>
                          {{ 'PANEL.LMS.ASSIGNMENTS.SUBMITTED' | translate }}
                        </span>
                        <span class="tag tag-light-primary" *ngIf="item.status==20">
                          <svg-icon src="/assets/Icons/new/check-circle.svg"></svg-icon>
                          {{ 'PANEL.LMS.ASSIGNMENTS.DONE' | translate }}
                        </span>
                        <span class="tag tag-blue" *ngIf="item.status==10">
                          {{ 'PANEL.LMS.ASSIGNMENTS.NEEDS_IMPROVEMENT' | translate }}
                        </span>
                      </div>
                      <div class="sub" *ngIf="item.dueDate">
                        {{ 'PANEL.LMS.ASSIGNMENTS.DUE' | translate }} <span>{{item.dueDate | date:'MMM d h:mm a'}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="more d-flex">
                    <div class="tag tag-2 me-2" *ngIf="item.isSubmitted">{{item.submitDate | date:'MMMM d'}} -
                      <ng-container *ngIf="item.onTime">{{ 'PANEL.LMS.ASSIGNMENTS.ON_TIME' | translate }}</ng-container>
                      <ng-container *ngIf="!item.onTime">{{ 'PANEL.LMS.ASSIGNMENTS.LATE_SUBMISSION' | translate }}</ng-container>
                    </div>
                    <a [routerLink]="['./assignments',item.id]" routerLinkActive="router-link-active"
                      [queryParamsHandling]="'preserve'" class="btn btn-text d-flex align-items-center gap-2">
                      {{ 'PANEL.LMS.LESSONS.VIEW_DETAILS' | translate }}
                      <svg-icon src="/assets/Icons/new/angle-right-green.svg"></svg-icon>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            }
          </div>

        </ng-template>
      </div>
    </div>
  </div>

</div>

<ng-container *ngIf="loading">
  <div class="accordion">
    <div class="accordion-item" *ngFor="let item of [1,2]">
      <h2 class="accordion-header collapsed">
        <button class="accordion-button collapsed">
          <div class="d-flex align-items-center justify-content-between w-100">
            <p-skeleton width="300px"></p-skeleton>
            <p-skeleton width="100px"></p-skeleton>
          </div>
        </button>
      </h2>
    </div>
  </div>
</ng-container>